const {partnerData, migrateClientIds} = require("./data");
const getPartnerData = (hostname = window && window.location.hostname) => {
    const partner = partnerData.find(p => p.host === hostname)
    return partner || partnerData[0]
}

exports.partnerData = partnerData

exports.getUserPartner = (user) => {
    if (typeof window !== 'undefined') { return getPartnerData() }
    if (user.attributes && user.attributes.clientId) {
        const partner = partnerData.find(p =>
            p.cognitoClientId === user.attributes.clientId ||
            (p.oldCognitoClientIds && p.oldCognitoClientIds.includes(user.attributes.clientId))
        )
        return partner || partnerData[1]
    }
    const lastHost = user.attributes && user.attributes.lastHost
    if (lastHost) { return getPartnerData(lastHost) }
    return null
}

exports.getPartnerData = getPartnerData
exports.activeTokens = partnerData

exports.getUserPool = (origin) => {
    const host = origin.split('://')[1].split(':')[0]
    const data = getPartnerData(host)
    return data.aws_user_pools_id
}

exports.getPartnerId = (clientId) => {
    const result = partnerData.find(t =>
        t.cognitoClientId === (migrateClientIds[clientId] || clientId)
        ||
        t.oldCognitoClientIds && t.oldCognitoClientIds.find(o => o === clientId)
    )
    return (result && result.partnerId) || 0
}

exports.getOneSignalTokens = getOneSignalTokens

function getOneSignalTokens(lastHost) {
    const result = partnerData.find(t => t.host === lastHost)
    return result ||
    {
            appId: 'd48134b7-ab16-4065-9ff8-54a3465f258a',
            token: 'MjEwNGJhOTgtZTdjNy00MTdmLWJkOTItNjUyN2Q2N2YxM2E5'
    }
}

const getPartnerHost = (partnerId) => {
    const partner = partnerData.find(p => p.partnerId===partnerId)
    if (partner && partner.host) {
        return partner.host
    }
    return 'fleetmap.io'
}
exports.getPartnerHost = getPartnerHost

exports.getPartnerEmails = (partnerId) => {
    const data = getPartnerData(getPartnerHost(partnerId))
    return data.email || 'reports.fleetmap@gmail.com'
}

exports.newDomains = [
    'aft-systems.org',
    'web.fleetmap.pt',
    'vz.samtech.cl',
    'api2.pinme.io',
    'afconsultingsystems.com',
    'web.fleetrack.cl',
    'plataforma.ubisat.cl',
    'geoloc.fleetmap.io',
    'sa-alb.fleetmap.pt',
    'localhost',
    'plataforma.puntosat.cl',
    'web.fleetrack.cl',
    'retatrack.com',
    'localizegps.com',
    'web.localizalia.net',
    'web.moviflotte.com',
    'sa-east-1-git-dev-fleetmap.vercel.app'
]
